module.exports = __webpack_public_path__ + "img/shape-002.80464f8d.svg";